import { helpers } from '@vuelidate/validators';
import { unref } from 'vue';

// REGEX from Symfony's EmailValidator and added umlauts
// eslint-disable-next-line
const emailRegex = /^[öäüÖÄÜßa-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[öäüÖÄÜßa-zA-Z0-9](?:[öäüÖÄÜßa-zA-Z0-9-]{0,61}[öäüÖÄÜßa-zA-Z0-9])?(?:\.[öäüÖÄÜßa-zA-Z0-9](?:[öäüÖÄÜßa-zA-Z0-9-]{0,61}[öäüÖÄÜßa-zA-Z0-9])?)*$/;
export const email = helpers.regex(emailRegex);
export const isEmail = email;

// Enforce comma as float separator, optionally dots as thousand separators (every 3 numbers). No non-numeric characters
export const validNumberFormatRegex = /^(?:\d{1,3}(?:\.\d{3})*|\d+)(?:,\d+)?$/;
export const isValidNumberFormat = helpers.regex(validNumberFormatRegex);

export function dateRange(start, end) {
    return helpers.withParams({ type: 'dateRange', start, end }, (value) => {
        if (value === undefined || value === null) return true;

        return unref(start) <= unref(end);
    });
}

export function maxDate(max) {
    return helpers.withParams({ type: 'maxDate', max }, (value) => {
        if (value === undefined || value === null) return true;

        return new Date(value).valueOf() <= max.valueOf();
    });
}

export function minDate(min) {
    return helpers.withParams({ type: 'minDate', min }, (value) => {
        if (value === undefined || value === null) return true;

        return new Date(value).valueOf() >= min.valueOf();
    });
}

export function validateIf(condition, validator) {
    return helpers.withParams({ type: 'validateIf ', condition }, (value) => {
        const conditionEvaluation = typeof unref(condition) === 'function' ? unref(condition()) : unref(condition);
        if (!conditionEvaluation) return true;
        return validator.$validator?.(value) ?? validator(value);
    });
}
